import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { AdGroupColumn as AdGroupColumnConfig } from '@bingads-webui-campaign/ads-data';
import adGroupTemplate from './ad-group.pug';

export class AdGroupColumn extends CampaignuiBaseColumn {
  constructor({
    i18n, scope, routeTemplate, isForVNext,
  }) {
    super({
      ...AdGroupColumnConfig,
      title: i18n.getString('ColumnName_AdGroup'),
      sortable: 'AdGroup/Name',
      editable: true,
      type: 'string',
      bodyClasses: ['grid-column-AdGroup'],
    });

    this.i18n = i18n;
    this.scope = scope;
    this.routeTemplate = routeTemplate;
    this.isForVNext = isForVNext;
  }

  pickProperty(item) {
    const { customerId: cid, accountId: aid } = this.scope;
    const {
      Campaign: {
        Id: cmpid,
      } = {},
      AdGroup: {
        Name: name,
        Id: adgid,
      } = {},
    } = item;

    return {
      isForVNext: this.isForVNext,
      name,
      cmpid,
      adgid,
      href: this.routeTemplate({
        cid,
        aid,
        cmpid,
        adgid,
      }),
      ariaLabel: this.i18n.getString('Click to scope to ad group {{adGroupName}}', { adGroupName: name }),
    };
  }

  get template() { return adGroupTemplate; }
}
